<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRedshiftResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../redshift/TableExpand.vue";
var tableRedshiftResourceVue = {};
export default {
  name: "TableRedshiftResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.Redshift.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Redshift.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterName"),
          key: "clusterIdentifier"
        },
        {
          title: "FQDN",
          key: "address"
        },
        {
          title: this.$t("RAM.AWS.Redshift.clusterStatus"),
          key: "clusterStatus"
        },
        {
          title: this.$t("RAM.AWS.Redshift.databaseStatus"),
          key: "status"
        },
        {
          title: this.$t("RAM.AWS.Redshift.releaseStatus"),
          key: "releaseStatus"
        }
      ],
      tableRedshiftResourceListData: []
    };
  },
  beforeCreate: function() {
    tableRedshiftResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("clusterIdentifier", function(val) {
      tableRedshiftResourceVue.clusterIdentifier = val;
    });
    eventBus.$on("companyId", function(val) {
      tableRedshiftResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableRedshiftResourceVue.getRedshiftResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getRedshiftResourceListData: function() {
      this.$api.resourceManagement
        .selectClusterByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: this.companyId,
          clusterIdentifier: tableRedshiftResourceVue.clusterIdentifier
        })
        .then(res => {
          this.tableRedshiftResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRedshiftResourceVue.getRedshiftResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRedshiftResourceVue.getRedshiftResourceListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("clusterIdentifierSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/redshift/TableRedshiftResource.vue